import * as React from "react"
import PropTypes from "prop-types"
import HeaderNew from "../header/header-new"
import HomeContactSectionUpdate from "../sections/ContactSection/home-contact-section-update"
import CommitmentSignature from "../sections/CommitmentSignature"
import FooterNewUpdateVersion from "../footer/footer-new-update-version"

const LayoutUpdate = ({ children, isHome = false }) => {
  return (
    <>
      <HeaderNew isHome={isHome} />
      <div className="mt-14 lg:mt-20">
        <main>{children}</main>
      </div>
      <HomeContactSectionUpdate />
      <CommitmentSignature />
      <FooterNewUpdateVersion />
    </>
  );
};

LayoutUpdate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutUpdate;